export enum TaskStatus {
    OPEN = "OPEN",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETE = "COMPLETE",
    CANCELLED = "CANCELLED"
}

export enum TaskClosureReason {
    NOT_INTERESTED = "NOT INTERESTED",
    NOT_SERVICEABLE_AREA = "NOT SERVICEABLE AREA",
    FOLLOW_UP_CALL_REQUESTED = "FOLLOW-UP CALL REQUESTED",
    BACHELOR_ACCOMMODATION = "BACHELOR ACCOMMODATION",
    PIL_VINTAGE_NOT_MET = "PIL VINTAGE NOT MET",
    DOCUMENTS_NOT_AVAILABLE = "DOCUMENTS NOT AVAILABLE",
    APPLICATION_CREATED = "APPLICATION CREATED",
    NOT_CONTACTABLE = "NOT CONTACTABLE",
    BUREAU_REJECT = "BUREAU REJECT",
    FV_ADDRESS_NOT_FOUND = "FV ADDRESS NOT FOUND",
    FV_CUSTOMER_DENIED_TO_MEET = "FV CUSTOMER DENIED TO MEET",
    FV_COMPLETED = "FV COMPLETED"
}

export const TASK_TYPE = "TASK";

export enum TaskType {
    ACTION = "ACTION",
    APPROVAL = "APPROVAL",
    SIMPLE_TASK = "SIMPLE_TASK",
    LEAD_FOLLOW_UP = "LEAD_FOLLOW_UP",
    VERIFICATION = "VERIFICATION"
}

export interface Task {
    taskId: string;
    status: TaskStatus;
    closureReason: string;
    assignee: string;
    tenantId: string;
    resourceId: string;
    resourceType: string;
    author: string;
    type: TaskType;
    dueDateInUTCEpoch: number;
    createDateInUTCEpoch: number;
    updateDateInUTCEpoch: number;
    updatedBy: string;
    title: string;
    description: string;
    watchers: string[];
    priority: number;
    isBlocked: boolean;
    labels: string[];
    contextData: Record<string, string>;
}
